<template>
<div>
    <div v-if="showDropzone">
        <div class="upload-file">
            <vue-dropzone id="dropzone" ref="dropzone" :options="dropzoneOptions" 
            v-on:vdropzone-queue-complete="afterComplete()"></vue-dropzone>
        </div>
    </div>
    <div>
        <div class="current-audio my-3">
            <div class="pb-3 border-bottom" v-for="file in files" v-bind:key="file.id">
                <div class="mb-3">
                    <audio :src="file.url" controls>Message</audio>
                </div>
                <strong>
                    {{ file.file_name }}
                </strong>
                <span class="badge badge-danger clickable remove float-right" @click="removeItem(file.id)">remove</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import vueDropzone from "vue2-dropzone";
    import eventHub from '../components/EventHub';


    export default {

        mounted() {
            this.refresh();
        },

        props:['model_id'],

        components: {
            vueDropzone
        },

        props:['model_id','model_type'],

        data() {
            return {
                dropzoneOptions: {
                    url: '/admin/upload',
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                    },
                    params: {'model_id': this.model_id, 'model_type': this.model_type, 'collection': 'audio' },
                },
                upload: true,
                files: [],
                errors: []
            }
        },

        
        computed: {

            showDropzone(){
                if(this.files.length){
                    return false;
                }
                return true;
            },

        },

        methods: {

            
            // sendingEvent (file, xhr, formData) {
            //     formData.append('paramName', 'some value or other');
            // },

            afterComplete() {
                this.$refs.dropzone.removeAllFiles();
                eventHub.$emit('audioAdded', 'true');
                this.refresh();
            },

            queueComplete(){
                console.log('queue complete');
                this.$refs.dropzone.removeAllFiles();
            },

            complete(response){
                console.log('complete');
                console.log(response);
            },

            afterSuccess(file, response){
                console.log('afterSuccess');
            },

            removeItem(id){
                console.log(id);
                this.errors = [];
                axios.post('/admin/deleteSpatieMedia', { 
                    id: id,
                 })
                .then(response => {
                    this.message = response.data.message;
                    this.refresh();
                })
                .catch(errors => {
                    this.errors = response.data.errors;
                });
            },

            refresh(){
                let url = '/admin/getMedia/' + this.model_type + '/' + this.model_id + '/audio';
                axios.get(url)
                .then(response => {
                    this.files = response.data.pictures;
                })
                .catch(errors => {
                    this.errors = response.data.errors;
                });
            },
        },

    }

</script>


<style scoped>
 audio {
     width: 100%;
 }
</style>